<template>
  <transition name="toast-fade">
    <div v-if="visible" class="toast" :class="type">
      <span class="toast-icon">{{ icon }}</span>
      <span class="toast-message">{{ message }}</span>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'Toast',
  data() {
    return {
      visible: false,
      message: '',
      type: 'info', // success, error, warning, info
      duration: 3000,
      timer: null
    }
  },
  computed: {
    icon() {
      const icons = {
        success: '✓',
        error: '✕',
        warning: '⚠',
        info: 'ℹ'
      }
      return icons[this.type] || icons.info
    }
  },
  methods: {
    show(message, type = 'info', duration = 3000) {
      this.message = message
      this.type = type
      this.duration = duration
      this.visible = true
      
      if (this.timer) clearTimeout(this.timer)
      this.timer = setTimeout(() => {
        this.hide()
      }, this.duration)
    },
    hide() {
      this.visible = false
    }
  }
}
</script>

<style scoped>
.toast {
  position: fixed;
  top: 80px;
  left: 50%;
  transform: translateX(-50%);
  padding: 12px 24px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 14px;
  z-index: 9999;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  min-width: 200px;
  justify-content: center;
}

.toast-icon {
  font-size: 16px;
  font-weight: bold;
}

.toast-message {
  color: #fff;
}

/* 成功 */
.toast.success {
  background: linear-gradient(135deg, #52c41a 0%, #389e0d 100%);
}

/* 错误 */
.toast.error {
  background: linear-gradient(135deg, #ff4d4f 0%, #cf1322 100%);
}

/* 警告 */
.toast.warning {
  background: linear-gradient(135deg, #faad14 0%, #d48806 100%);
}

/* 信息 */
.toast.info {
  background: linear-gradient(135deg, #1890ff 0%, #096dd9 100%);
}

/* 动画 */
.toast-fade-enter-active,
.toast-fade-leave-active {
  transition: all 0.3s ease;
}

.toast-fade-enter {
  opacity: 0;
  transform: translateX(-50%) translateY(-20px);
}

.toast-fade-leave-to {
  opacity: 0;
  transform: translateX(-50%) translateY(-20px);
}
</style>
